<template>
  <div class="page-wrapper ticket-pay-wrapper">
      <!-- 返回 -->
      <div class="movie-box">
        <MovieGoBack :style="backstyle" :arrowStyle="arrowStyle" :text="'支付'" :titleStyle="titleStyle"></MovieGoBack>
      </div>

      <div class="page-background-color-white padding30 font-color-red page-text-center" v-if="expire_time">
          请在 {{expire_time}} 前完成支付！
      </div>
      
      <div class="page-background-color-white padding30 pay-content">
          <div class="movie-box acea-row row-between page-margin-bottom1">
            <span>订单创建时间</span>
            <span>{{orderInfor.create_time}}</span>
          </div>
          <div class="movie-box acea-row row-between page-margin-bottom1 moreName">
            <span class="nameTitle">门票</span>
            <span class="nameContent">{{orderInfor.tickets_name}}</span>
          </div>
          <div class="movie-box acea-row row-between page-margin-bottom1">
            <span>数量</span>
            <span>{{orderInfor.total_num}}</span>
          </div>
          <div class="movie-box acea-row row-between page-margin-bottom1">
              <span>价格</span>
              <span>{{orderInfor.price}}</span>
          </div>
      </div>

      <div class="page-background-color-white padding30 pay-content">
          <PaymentComponent :pay_price="orderInfor.price" :money="nowMoney" @payType="payType"></PaymentComponent>
      </div>
      

      <!-- 支付 -->
      <div @click="submitPay">
          <MovieBottomButton :text="'支付'"></MovieBottomButton>
      </div>
  </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";
import MovieBottomButton from "@components/MovieBottomButton.vue";
import PaymentComponent from "@components/PaymentComponent.vue";
import { getTicketOrderData } from "@api/ticket.js";
import { roundFun } from "@utils/movie.js";
import { payTicket } from "@api/ticket.js";
import { pay } from "@libs/wechat";

export default {
    name: "PayForTicket",
    components: {
        MovieGoBack,
        MovieBottomButton,
        PaymentComponent
    },
    data: function() {
        return{
            backstyle: {
                background: '#fff'
            },
            arrowStyle: {
                color: '#666'
            },
            titleStyle: {
                color: '#666',
                'text-align': 'center'
            },
            active: "",
            from: "",
            orderInfor: {
                id: this.$route.params.id || "",//订单id
                price: "0",//总价格
                create_time: "",//订单创建时间
                total_num: "",//数量
                tickets_name: "" //票品名
            },
            expire_time: null, //过期时间
            nowMoney: 0 //余额
        }
    },
    created: function () {
        this.getOrderPayInfor();
    },
    methods:{
        getOrderPayInfor: function () {
            const id = this.orderInfor.id || this.$route.params.id;
            getTicketOrderData(id).then((res)=>{
                let data = res && res.data && res.data.orderInfo;
                if (!data) return;
                this.orderInfor.price = roundFun(data.total_num * data.ctripprice, 2);
                this.orderInfor.create_time = data.create_time;
                this.orderInfor.total_num = data.total_num;
                this.orderInfor.tickets_name = data.tickets_name;
                this.expire_time = data.expire_time;
                const money = res && res.data && res.data.userInfo && res.data.userInfo.now_money || 0;
                this.nowMoney = money;
            }).catch((err)=>{
                let time = 1000;
                if (err.data.status == 400) {
                    time = 5000;
                }
                this.$dialog.error(err.msg, {}, time).then(()=>{
                    if (err.data.status == 400) {
                    this.$router.go(-1);
                    }
                });
            });
        },
        payType: function (val) {
            let { active, from } = val;
            this.active = active;
            this.from = from;
            // console.log(val,"支付方式");
        },
        submitPay: function() {
            let now = new Date().getTime();
            let _expire_time = new Date(this.expire_time.replace(/-/g,'/')).getTime();
            let differ = parseFloat(now - _expire_time)/1000;
            if (differ >= 0) {
                this.$dialog.error("已过期!请重新下单");
                this.$router.go(-1);
                return;
            }
            if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
            this.$dialog.confirm({
                mes: "确认支付?",
                opts: () => {
                    let info = {
                        oid: this.orderInfor.id || this.$route.params.id,
                        paytype: this.active,
                        from: this.from
                    };
                    this.$dialog.loading.open("正在支付中");
                    //支付接口
                    payTicket(info).then((res)=>{
                        this.$dialog.loading.close();
                        // console.log(res,"res");
                        this.$dialog.success(res.msg);
                        const data = res && res.data && res.data.status || "";
                        if (data == "SUCCESS" || data == "ORDER_EXIST" || data == "EXTEND_ORDER" || data == "PAY_DEFICIENCY" || data == "PAY_ERROR") {
                            this.$router.replace('/user');
                            return;
                        };
                        if (data == "WECHAT_H5_PAY") {
                            this.$router.replace('/user');
                            setTimeout(() => {
                                location.href = res.data.result.jsConfig.mweb_url;
                            }, 100);
                            return;
                        };
                        if (data == "WECHAT_PAY") {
                            pay(res.data.result.jsConfig).finally(() => {
                                this.$router.replace({ path: "/user" });
                            });
                            return;
                        };
                        this.$router.replace({ path: "/user" });
                            
                    }).catch((err)=>{
                        console.log(err);
                        this.$dialog.loading.close();
                        this.$dialog.error(err.msg || "创建订单失败" );
                        // if (err && err.msg && err.msg.indexOf("该订单已支付") !== -1) {
                            this.$router.replace('/user');
                        // }
                    });
                }
            })
        }
    }
}
</script>

<style scoped>
.ticket-pay-wrapper {
    padding-bottom: 1.2rem;
}
.pay-content {
    width: 92%;
    margin: .2rem auto 0;
    border-radius: .1rem;
}
.moreName {
    flex-wrap: nowrap;
}
.moreName .nameContent {
    width: 70%;
}
.moreName .nameTitle {
    width: 30%;
}
</style>